import { initIntersectionObserver } from "@plugins";
import jquery from "jquery";

const $ = jquery;

if (window.mobileMedia) {
    $(document).ajaxSuccess(() => initMoblieCardCharacteristicsIntersectionObserver());

    initMoblieCardCharacteristicsIntersectionObserver();
}

function initMoblieCardCharacteristicsIntersectionObserver() {
    const cardCharacteristics = document.querySelectorAll(".js-card-characteristics-mobile-init");

    if (cardCharacteristics) {
        for (const characteristics of cardCharacteristics) {
            initIntersectionObserver(characteristics, initCharacteristicsButtons);
        }
    }
}

function initCharacteristicsButtons(characteristics) {
    if (!characteristics.classList.contains("mobile-characteristics-initialized")) {
        const trigger = characteristics.querySelector(".js-card-characteristics-mobile-trigger");
        const closeBtn = characteristics.querySelector(".js-card-characteristics-mobile-close");
        const body = characteristics.querySelector(".js-card-characteristics-mobile-body");

        if (body && closeBtn && trigger) {
            trigger.addEventListener("click", () => {
                body.classList.add("active");

                closeBtn.addEventListener("click", () => {
                    body.classList.remove("active");
                });
            });

            characteristics.classList.add("mobile-characteristics-initialized");
        }
    }
}
